<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'InterfaceConfigurationList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Interface Configurations
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Interface Configurations</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="InterfaceConfiguration">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group required">
                    <label class="control-label">Name</label>
                    <input
                      type="text"
                      id="description"
                      name="Name"
                      :readonly="is_edit"
                      v-bind:class="{ 'has-error': errors.has('description') }"
                      v-validate="{
                        required: true,
                        max: 10,
                        regex: /^[a-zA-Z0-9]+$/,
                      }"
                      v-model="value.description"
                      class="form-control description"
                      placeholder="Input Name. (Name has to be unique.)"
                    />
                    <div class="help text-danger" v-show="errors.has('Name')">
                      {{ errors.first("Name") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Interface Type</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      id="interface_type"
                      name="interface_type"
                      readonly
                      v-model="value.interface_type"
                      class="form-control interface"
                    />
                    <multiselect
                      v-else
                      v-model="value.interface_type"
                      :options="pre.interfaceTypes"
                      @input="setProtocolsInterfaces"
                      placeholder="Select Interface Type"
                      :searchable="true"
                      :multiple="false"
                      id="interface_type"
                      v-bind:class="{
                        'has-error': errors.has('interface_type'),
                      }"
                      v-validate="'required'"
                      name="Interface Type"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('Interface Type')">
                      {{ errors.first("Interface Type") }}
                    </div>
                  </div>

                  <div
                    v-if="value.interface_type !== 'Loopback'"
                    class="form-group required"
                  >
                    <label class="control-label">Interface</label>

                    <input
                      v-if="
                        is_edit &&
                        (value.interface_type == 'Physical' ||
                          value.interface_type == 'Vlan')
                      "
                      type="text"
                      id="interface"
                      name="interface"
                      readonly
                      v-model="editInterface"
                      class="form-control interface"
                    />
                    <multiselect
                      v-else
                      v-model="value.interface"
                      :options="Object.keys(pre.interfaceOptions)"
                      :readonly="
                        is_edit &&
                        (value.interface_type == 'Physical' ||
                          value.interface_type == 'Vlan')
                      "
                      :custom-label="(opt) => pre.interfaceOptions[opt]"
                      placeholder="Select Interface"
                      :searchable="true"
                      :multiple="value.interface_type == 'Bridge' ? true : false"
                      id="interface"
                      v-bind:class="{ 'has-error': errors.has('interface') }"
                      v-validate="'required'"
                      name="interface"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('interface')">
                      {{ errors.first("interface") }}
                    </div>
                  </div>

                  <div v-if="value.interface_type == 'Vlan'" class="form-group required">
                    <label class="control-label">Virtual LAN Number</label>
                    <input
                      type="text"
                      id="vlan_no"
                      name="Virtual LAN Number"
                      v-bind:class="{ 'has-error': errors.has('vlan_no') }"
                      v-model="value.vlan_no"
                      class="form-control vlan_no"
                      placeholder="(2-4096) 1 reserve"
                      v-validate.lazy="'required'"
                      v-validate="{ max_value: 4096, min_value: 2 }"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('Virtual LAN Number')"
                    >
                      {{
                        `The VLAN number is required in proper format.(max=4096,min=2)`
                      }}
                    </div>
                  </div>

                  <div v-if="value.interface_type !== 'Loopback'" class="form-group">
                    <label class="control-label">Protocol</label>

                    <multiselect
                      v-model="value.protocol"
                      :options="Object.keys(pre.protocols)"
                      @input="protocolChanges"
                      :custom-label="(opt) => pre.protocols[opt]"
                      placeholder="Select Protocol"
                      :searchable="true"
                      :multiple="false"
                      id="protocol"
                      v-bind:class="{ 'has-error': errors.has('protocol') }"
                      name="protocol"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('protocol')">
                      {{ errors.first("protocol") }}
                    </div>
                  </div>

                  <div
                    v-if="
                      value.protocol == 'pppoe' &&
                      (value.interface_type == 'Physical' ||
                        value.interface_type == 'Bridge' ||
                        value.interface_type == 'Vlan')
                    "
                  >
                    <div class="form-group required">
                      <label class="control-label">User ID</label>
                      <input
                        type="text"
                        id="user_id"
                        name="user_id"
                        v-bind:class="{ 'has-error': errors.has('user_id') }"
                        v-model="value.user_id"
                        class="form-control user_id"
                        v-validate="'required'"
                        placeholder="User ID"
                      />
                      <div class="help text-danger" v-show="errors.has('user_id')">
                        {{ `The user id field is required.` }}
                      </div>
                    </div>
                    <div class="form-group required">
                      <label class="control-label">Password</label>
                      <input
                        type="text"
                        id="password"
                        name="password"
                        v-bind:class="{ 'has-error': errors.has('password') }"
                        v-model="value.password"
                        class="form-control password"
                        v-validate="'required'"
                        placeholder="Password"
                      />
                      <div class="help text-danger" v-show="errors.has('password')">
                        {{ errors.first("password") }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label">Service Name</label>
                      <input
                        type="text"
                        id="service_name"
                        name="service_name"
                        v-bind:class="{
                          'has-error': errors.has('service_name'),
                        }"
                        v-model="value.service_name"
                        class="form-control service_name"
                        placeholder="Service Name"
                      />
                      <div class="help text-danger" v-show="errors.has('service_name')">
                        {{ errors.first("service_name") }}
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="
                      value.interface_type == 'Loopback' || value.protocol == 'static'
                    "
                    class="form-group"
                  >
                    <label class="control-label">IP Address</label>
                    <input
                      type="text"
                      id="network_addr"
                      name="IP Address"
                      @input="setStartEndIP"
                      v-validate.lazy="'ip_CIDR'"
                      v-bind:class="{ 'has-error': errors.has('IP Address') }"
                      v-model="value.network_addr"
                      class="form-control network_addr"
                      :placeholder="ipPlaceholder"
                    />
                    <div class="help text-danger" v-show="errors.has('IP Address')">
                      {{ errors.first("IP Address") }}
                    </div>
                  </div>
                  <div
                    v-if="
                      value.protocol &&
                      (value.interface_type == 'Physical' ||
                        value.interface_type == 'Bridge' ||
                        value.interface_type == 'Vlan')
                    "
                  >
                    <div v-if="value.protocol == 'static'" class="form-group">
                      <label class="control-label">Gateway</label>
                      <input
                        type="text"
                        id="gateway"
                        name="gateway"
                        v-validate="'ip'"
                        v-bind:class="{ 'has-error': errors.has('gateway') }"
                        v-model="value.gateway"
                        class="form-control gateway"
                        placeholder="Example: 192.168.20.0"
                      />
                      <div class="help text-danger" v-show="errors.has('gateway')">
                        {{ errors.first("gateway") }}
                      </div>
                    </div>

                    <div v-if="value.protocol == 'static'" class="form-group">
                      <label class="control-label">DHCP Server</label>

                      <select
                        class="form-control"
                        name="is_dhcp"
                        v-bind:class="{ 'has-error': errors.has('is_dhcp') }"
                        id="is_dhcp"
                        v-model="value.is_dhcp"
                        @change="setStartEndIP"
                      >
                        <option :value="1">Yes</option>
                        <option :value="0">No</option>
                      </select>
                    </div>
                    <div v-if="value.is_dhcp == 1 && value.protocol == 'static'">
                      <div class="form-group">
                        <label class="control-label">Start IP</label>
                        <input
                          type="text"
                          id="dhcp_start_ip"
                          name="Start IP"
                          v-validate="'ip'"
                          v-bind:class="{
                            'has-error': errors.has('dhcp_start_ip'),
                          }"
                          v-model="value.dhcp_start_ip"
                          class="form-control dhcp_start_ip"
                          placeholder="Example: 192.168.20.100"
                        />
                        <div class="help text-danger" v-show="errors.has('Start IP')">
                          {{ errors.first("Start IP") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label">End IP</label>
                        <input
                          type="text"
                          id="dhcp_end_ip"
                          name="End IP"
                          v-validate="'ip'"
                          v-bind:class="{
                            'has-error': errors.has('dhcp_end_ip'),
                          }"
                          v-model="value.dhcp_end_ip"
                          class="form-control dhcp_end_ip"
                          placeholder="Example: 192.168.20.250"
                        />
                        <div class="help text-danger" v-show="errors.has('End IP')">
                          {{ errors.first("End IP") }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="control-label">Lease Time (hrs)</label>
                        <input
                          type="text"
                          id="lease_time"
                          name="lease time"
                          v-model="value.lease_time"
                          class="form-control lease_time"
                          placeholder="Example: 1 (1 to 240 hrs)"
                          v-validate="'between:1,240'"
                        />
                        <div class="help text-danger" v-show="errors.has('lease time')">
                          {{ errors.first("lease time") }}
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">DNS</label>
                      <input
                        type="text"
                        id="dns"
                        name="dns"
                        v-bind:class="{ 'has-error': errors.has('dns') }"
                        v-validate="'ip'"
                        v-model="value.dns"
                        class="form-control dns"
                        placeholder="Example: 8.8.8.8"
                      />
                      <div class="help text-danger" v-show="errors.has('dns')">
                        {{ errors.first("dns") }}
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="control-label">Alternate DNS</label>
                      <input
                        type="text"
                        id="alternate_dns"
                        name="Alternate DNS"
                        v-validate="'ip'"
                        v-bind:class="{
                          'has-error': errors.has('alternate_dns'),
                        }"
                        v-model="value.alternate_dns"
                        class="form-control alternate_dns"
                        placeholder="Example: 4.2.2.2"
                      />
                      <div class="help text-danger" v-show="errors.has('Alternate DNS')">
                        {{ errors.first("Alternate DNS") }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Labeling</label>

                    <multiselect
                      v-if="value.interface_type === 'Alias'"
                      v-model="value.labeling"
                      :options="Object.keys(pre.labelingOptionsAlias)"
                      :custom-label="(opt) => pre.labelingOptionsAlias[opt]"
                      placeholder="Select Labeling"
                      :searchable="true"
                      :multiple="false"
                      id="labeling"
                      v-bind:class="{ 'has-error': errors.has('labeling') }"
                      v-validate="'required'"
                      name="labeling"
                    >
                    </multiselect>
                    <multiselect
                      v-else-if="value.interface_type === 'Loopback'"
                      v-model="value.labeling"
                      :options="Object.keys(pre.labelingOptionsLoopback)"
                      :custom-label="(opt) => pre.labelingOptionsLoopback[opt]"
                      placeholder="Select Labeling"
                      :searchable="true"
                      :multiple="false"
                      id="labeling"
                      v-bind:class="{ 'has-error': errors.has('labeling') }"
                      v-validate="'required'"
                      name="labeling"
                    >
                    </multiselect>
                    <multiselect
                      v-else
                      v-model="value.labeling"
                      :options="Object.keys(pre.labelingOptions)"
                      :custom-label="(opt) => pre.labelingOptions[opt]"
                      placeholder="Select Labeling"
                      :searchable="true"
                      :multiple="false"
                      id="labeling"
                      v-bind:class="{ 'has-error': errors.has('labeling') }"
                      v-validate="'required'"
                      name="labeling"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('labeling')">
                      {{ errors.first("labeling") }}
                    </div>
                  </div>

                  <div v-if="value.labeling == 'WAN'" class="form-group">
                    <label class="control-label">Gatway Metric</label>
                    <input
                      type="text"
                      id="gateway_metric"
                      name="gateway_metric"
                      v-bind:class="{
                        'has-error': errors.has('gateway_metric'),
                      }"
                      v-model="value.gateway_metric"
                      class="form-control gateway_metric"
                      placeholder="Example: 10"
                    />
                    <div class="help text-danger" v-show="errors.has('gateway_metric')">
                      {{ errors.first("gateway_metric") }}
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="control-label">STP</label>

                    <select
                      class="form-control"
                      name="stp"
                      v-bind:class="{ 'has-error': errors.has('stp') }"
                      id="stp"
                      v-model="value.stp"
                    >
                      <option :value="1">ENBALE</option>
                      <option :value="0">DISABLE</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "InterfaceConfigurationForm",
  metaInfo: {
    title: "Interface Configurations | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      dhcp_start_ip: "",
      dhcp_end_ip: "",
      is_dhcp: 1,
      alternate_dns: "",
      dns: "",
      gateway: "",
      lease_time: 12,
    },
    pre: {
      interfaceTypes: [],
      interfaceOptions: [],
      protocols: {
        dhcp: "DHCP Client",
        pppoe: "PPPoE Client",
        static: "Static",
      },
      labelingOptions: { LAN: "LAN", WAN: "WAN" },
      labelingOptionsAlias: { Alias: "Alias" },
      labelingOptionsLoopback: { Loopback: "Loopback" },
      hashInterface: {
        "eth0|ETH-1": "ETH-1",
        "eth1|ETH-2": "ETH-2",
        "eth2|ETH-3": "ETH-3",
        "eth3|ETH-4": "ETH-4",
        "eth4|ETH-5": "ETH-5",
        "eth5|ETH-6": "ETH-6",
      },
    },
    editInterface: "",
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/interface_configurations";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/interface_configurations/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "InterfaceConfigurationList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/interface_configurations/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
            if (this.value.interface_type === "Bridge") {
              this.value.interface = this.value.interface.split(",");
            }
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back();
          });
        if (
          this.value.interface_type == "Physical" ||
          this.value.interface_type == "Vlan"
        ) {
          this.editInterface = this.pre.hashInterface[this.value.interface];
          if (!this.editInterface) this.editInterface = this.value.interface;
        }
      } else {
        this.value.accountId = LocalStorage.get("accountId");
        const devType = LocalStorage.get("deviceType");

        if (devType == "MT7621_NO_WIFI") {
          this.value.interface_type = "Alias";
        } else {
          this.value.interface_type = "Physical";
        }

        this.value.stp = 0;
      }

      await this.getInterfaceTypes()
        .then((response) => {
          this.pre.interfaceTypes = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getInterfaceOptions(this.value.interface_type)
        .then((response) => {
          this.pre.interfaceOptions = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
      this.setCustomValidation();
    },

    getInterfaceOptions: function (interfaceType) {
      return new Promise((resolve, reject) => {
        axios
          .get("get-interface-options", {
            params: {
              accountId: LocalStorage.get("accountId"),
              isEdit: this.is_edit ? 1 : "",
              id: this.is_edit ? this.value.id : "",
              interface_type: interfaceType,
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    getInterfaceTypes: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("get-interface-types", {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    setProtocolsInterfaces() {
      if (
        this.value.interface_type == "Physical" ||
        this.value.interface_type == "Vlan"
      ) {
        this.pre.protocols = {
          dhcp: "DHCP Client",
          pppoe: "PPPoE Client",
          static: "Static",
        };
      } else if (this.value.interface_type == "Bridge") {
        this.pre.protocols = { dhcp: "DHCP Client", static: "Static" };
      } else if (this.value.interface_type == "Alias") {
        this.pre.protocols = { static: "Static" };
      } else {
        this.pre.protocols = {};
        this.value.protocol = "";
        this.value.dns = "";
        this.value.alternate_dns = "";
        this.value.service_name = "";
        this.value.user_id = "";
        this.value.password = "";
        this.value.gateway = "";
        this.value.is_dhcp = "";
        return;
      }

      this.is_loading = true;
      this.getInterfaceOptions(this.value.interface_type)
        .then((response) => {
          this.pre.interfaceOptions = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },

    unMethod(n) {
      return n >>> 0;
    },

    setIpRange() {
      const addr = this.value.network_addr;

      if (!addr) return;

      const m = addr.match(/\d+/g);
      const addr32 = m.slice(0, 4).reduce((a, o) => this.unMethod(+a << 8) + +o, 0);
      const mask = this.unMethod(~0 << (32 - +m[4]));

      const start = this.unMethod(addr32 & mask);
      const end = this.unMethod(addr32 | ~mask);

      // this.value.gateway = this.ip(addr.split('/')[0] + 1)
      // this.value.gateway = addr.split('/')[0]

      this.value.dhcp_start_ip = this.ip(start + 2);
      this.value.dhcp_end_ip = this.ip(end - 2);
    },

    setStartEndIP() {
      if (this.value.is_dhcp === 1) {
        this.setIpRange();
      } else {
        this.dhcp_start_ip = "";
        this.dhcp_end_ip = "";
      }
    },

    protocolChanges() {
      // console.log(this.value.protocol);
      if (this.value.protocol !== "pppoe") {
        this.value.user_id = "";
        this.value.password = "";
        this.value.service_name = "";
      }

      this.$forceUpdate();
    },

    setCustomValidation: function () {
      this.$validator.extend("ip_CIDR", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 192.168.20.0/24",
        validate: (value) => {
          return this.validateIpCidr(value) ? true : false;
        },
      });

      this.$validator.extend("ip_PRE", {
        getMessage: (field) =>
          "The input format is invalid. Valid Format : 192.168.20.0/24",
        validate: (value) => {
          return this.validateIpCidr(value) ? true : false;
        },
      });
    },

    validateIpCidr(value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },

    ip(n) {
      return [
        (n >>> 24) & 0xff,
        (n >>> 16) & 0xff,
        (n >>> 8) & 0xff,
        (n >>> 0) & 0xff,
      ].join(".");
    },
  },
  mounted() {
    this.initialize();
  },
  computed: {
    dhcpValue() {
      // Set value.is_dhcp to 1 (Yes) if value.dhcp is undefined
      return this.value.dhcp === undefined ? 1 : this.value.is_dhcp;
    },
    ipPlaceholder() {
      if (this.value.interface_type === "Loopback") {
        return "Example: 45.125.222.187/32";
      } else if (this.value.protocol === "static") {
        return "Example: 192.168.21.1/24";
      } else {
        return "Example: 192.168.21.1/24";
      }
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
